import React from 'react';
import './Gallonbot.css';
import gallonbo from '../../../imgs/gallonbott.webp';

const Gallonbot = () => {
    return (
        <div className="Cavity-container">
            <div className='Cavitys'>
                <h2 className="Cavity-title">5 Gallon Bottle Caps Injection Molding Production Line</h2>
                <p className="Cavity-date">Oct. 8, 2022</p>

                <div className="Cavity">
                    <img src={gallonbo} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                    <div className="Cavity-content">

                        <p className="Cavity-text">
                            The 5 gallon bottle cap refers to the plastic cap of the 5-gallon drinking bottled water, which is an important part of bottled water. It plays the role of sealing the entire bucket to prevent the growth of bacteria, so it is widely used in the packaging of bottled water.
                            5 Gallon Non-Spill Bottle Caps are typically injection molded with food-grade polyethylene (PE) material.
                        </p>
                        <p className="Cavity-text">How to improve the injection speed and accuracy of the disposable and easy-to-wear 5 gallon water bottle caps, reduce the burr of the product and reduce the defect rate, 
                            has become the focus of bottled water plastic cap manufacturers.</p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Gallonbot;
